const QC_WORK_BENCH_SCENE = {
  scene_code: 'QCworkbench',
  scene_name: '质控工作台',
};
export const COPILOT_TRACKS = {
  copilotTermClick: {
    ...QC_WORK_BENCH_SCENE,
    scene_type: 'CopilotTerm',
    event_name: '复制原文添加术语',
    event_type: 'click',
    event_code: 'QCworkbench_CopilotTerm_click',
  },
  copilotClick: {
    ...QC_WORK_BENCH_SCENE,
    scene_type: 'copilot',
    event_name: '点击副驾图标',
    event_type: 'click',
    event_code: 'QCworkbench_copilot_click',
  },
  copilotQAClick: {
    ...QC_WORK_BENCH_SCENE,
    scene_type: 'CopilotQA ',
    event_name: '快捷全局QA',
    event_code: 'QCworkbench_CopilotQA_click',
    event_type: 'click',
  },
  copilotTranClick: {
    ...QC_WORK_BENCH_SCENE,
    scene_type: 'CopilotTran',
    event_name: '快捷调用GPT翻译',
    event_code: 'QCworkbench_CopilotTran_click',
    event_type: 'click',
  },
  copilotPolishClick: {
    ...QC_WORK_BENCH_SCENE,
    scene_type: 'CopilotPR',
    event_name: '快捷调用GPT润色',
    event_code: 'QCworkbench_CopilotPR_click',
    event_type: 'click',
  },
};

const QC_COPILOT_FILTER_SCENE = {
  scene_code: 'CopilotFilter',
  scene_name: '副驾筛选页',
};
export const COPILOT_FILTER_TRACKS = {
  openFilterMode: {
    ...QC_COPILOT_FILTER_SCENE,
    event_name: '展示筛选页面',
    event_code: 'CopilotWorkbench_CopilotFilter_expose',
    event_type: 'expose',
  },
  closeFilterMode: {
    ...QC_COPILOT_FILTER_SCENE,
    scene_type: 'FilterPageExit',
    event_name: '退出副驾页面',
    event_code: 'CopilotWorkbench_FilterPageExit_click',
    event_type: 'click',
  },
  submitSent: {
    ...QC_COPILOT_FILTER_SCENE,
    event_name: '在筛选页面提交句子',
    event_code: 'CopilotWorkbench_CopilotFilter_click',
    event_type: 'click',
  },
};
